<template>
  <div class="PresentPersonelListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
      :selectedItem="selectedItem"
    >
    <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details="true"
          v-model="isCheckAll"
          @change="checkAll()"
        ></v-checkbox>
      </template>
      <template v-if="show" v-slot:item.select="{ item }">
        <v-checkbox
          dense
          hide-details="true"
          v-model="item.select"
          v-bind="item.select"
          @change="checkboxUpdated($event, item)"
          @click.stop=""
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    selectedItem:[],
    approved:Boolean,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
   // list() {
   //   this.selectedList = [];
   // },
  },
  data() {
    return {
      show:true,
      isCheckAll: false,
      selectedList: [],
      headers: [
        {
          text: this.$t(""),
          value: "select",
        },
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("SectionName"),
          value: "Section",
        },
        {
          text: this.$t("WorkGroup"),
          value: "WorkGroupName",
        },
       
      ],
      
    };
  },
  mounted() {
    debugger;
    this.checkApproved();
    var selectedIds = [...this.selectedItem];
     var list = [...this.list];
 list.forEach((element) => {
   debugger;
   const data = list.filter((item) => (selectedIds.includes(item.PERNO.trim())));
  var num=data.find(item => item.PERNO.trim()==element.PERNO.trim());
  if(num){
   element.select = true;
  }else{
   element.select = false;
  }
      

     });
    this.selectedList=selectedIds;
    this.selectedItem=[...this.selectedList];
  },
  methods: {
    checkAll() {
      var list = [...this.list];
      if (this.isCheckAll) {
        list.forEach((element) => {
          element.select = true;
        });
      } else {
        list.forEach((element) => {
          element.select = false;
        });
      }
    this.selectedItem=[...this.selectedList];
      this.list = list;
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
    checkboxUpdated(newValue, item) {
      debugger;
      console.log(newValue, item);
      var pERNO=item.PERNO.trim();
      var num = false;
      if(this.selectedList.length>0){
        num=this.selectedList.find(o=>o.PERNO==pERNO);
      }
      if(newValue && !num){
        this.selectedList.push(pERNO);
      }
      if(!newValue && num){
        this.selectedList=this.selectedList.filter(o=>o!=pERNO)
      }
      this.selectedItem=[...this.selectedList];
      ////console.log(num);
    },
    checkApproved(){
      //debugger
      if(this.approved){
        this.show=false;
        this.headers.splice(8)
      }
    },
      checkApprovedSelect(){
      //debugger
      if(this.approved){
        this.show=false;
        //debugger
       
       
      }
    },
    
  },
};
</script>

<style>
tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.329);
}
</style>





